export default __webpack_public_path__ + "static/media/a024-4.68fb478a.svg";